import React from "react";
import { TestimonialBlock } from "../components/testimonial";
import { Link } from "react-router-dom";
import FaceJeff from "@/assets/images/markus-r.png";
import Hero from "@/assets/images/advisor-hero.jpg";

/* Container */
const Container: React.FC<React.PropsWithChildren<{ className?: string }>> = ({
  className = "",
  children,
}) => (
  <div className={`mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8 ${className}`}>
    {children}
  </div>
);

export default function ServicesAdvisoryChangePage() {
  return (
    <section className="py-14 text-white">
      <Container>
        {/* Back link */}
        <Link
          to="/services"
          className="inline-flex items-center text-sm text-white/60 hover:text-white mb-6 transition"
        >
          ← Services
        </Link>

        {/* Header */}
        <div className="mb-12">
          <h2 className="font-display text-5xl md:text-7xl mb-6">
            Driving change
          </h2>
          <p className="text-lg md:text-2xl leading-7 md:leading-9 text-white/60">
            We help organisations turn strategy into action, creating alignment,
            clarity, and capability to drive digital success.
          </p>
        </div>

        {/* Meta section */}
        <div className="flex flex-col md:flex-row gap-10 md:gap-40 text-white/60 mb-10">
          {/* Left column */}
          <div className="space-y-6">
            <div>
              <h3 className="font-semibold text-white">Clients</h3>
              <ul className="space-y-1">
                <li>Scandinavian Cosmetic</li>
              </ul>
            </div>
          </div>

          {/* Right column */}
          <div className="space-y-6">
            <div>
              <h3 className="font-semibold text-white">What we did</h3>
              <ul className="space-y-1">
                <li>Workshops & Facilitation</li>
                <li>Organisational alignment</li>
                <li>Product strategy & governance</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Image */}
        <img src={Hero} alt="Workshops & Training" className="mb-10" />

        {/* Body text */}
        <div className="mb-8 text-lg md:text-2xl leading-7 md:leading-9 leading-relaxed w-full md:w-3/4 text-white/80">
          <p>
            By combining process governance, change management, and business
            development, we make digital transformation more structured and
            sustainable. We support leaders and teams through workshops,
            coaching, and hands-on help with product strategy, roadmaps,
            governance, and cross-team collaboration.
          </p>

          <p className="mt-4">
            Recently, we supported{" "}
            <span className="text-white font-bold">Scandinavian Cosmetic</span>{" "}
            in their work to create stronger alignment across people, processes,
            technology, and data. Together we clarified roles and
            responsibilities and identified and documented their core
            organisational processes.
          </p>
        </div>

        {/* Testimonial 
        <TestimonialBlock
          quote="BoldBrave bring clarity, structure and energy. They helped us sharpen our digital strategy and elevate the way we work — while moving the business forward every single week."
          author="— Client Lead, Scandinavian Cosmetic"
          role="Head of Digital & IT"
          avatar={FaceJeff}
        />
        */}
      </Container>
    </section>
  );
}
